module.exports = __webpack_public_path__ + "static/media/TUNE_4510.d6814911.jpg";